module.exports = __webpack_public_path__ + "img/optimism.6d16914e.svg";